export default {
  title: 'Seneste 4 uger',
  item_interval: '(1)[1 besøg];(2)[2 besøg];(3-5)[3-5 besøg];(6-inf)[6+ besøg];',
  total: 'Besøgende i alt',
};
